// pages/mobile/FieldStaffHome.js
// The "Me" tab of the field staff app: account, phone setup and sign out.
import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import api from '../../authentication/axiosInstance';
import { TabBar } from './MobileChrome';
import { BellIcon } from './icons';
import styles from './mobile.module.css';

const FieldStaffHome = () => {
  const { userEmail, setIsAuthenticated, setUserRole } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    try {
      if (refreshToken) {
        await api.post('/users/logout/', { refresh_token: refreshToken });
      }
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      setIsAuthenticated(false);
      setUserRole(null);
      navigate('/login');
    }
  };

  return (
    <main className={`${styles.page} ${styles.pageWithTabs}`}>
      <header className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Me</h1>
        <p className={styles.mutedText}>
          You're signed in{userEmail ? ` as ${userEmail}` : ''}. You stay signed in on this phone until you sign out.
        </p>
      </header>
      <div className={styles.content}>
        <Link to="/m/setup" className={styles.banner}>
          <BellIcon />
          <span>Phone setup: install the app and turn on notifications.</span>
          <span className={styles.bannerAction}>Open</span>
        </Link>
        <button type="button" className={styles.secondaryButton} onClick={handleSignOut}>
          Sign out
        </button>
      </div>
      <TabBar />
    </main>
  );
};

export default FieldStaffHome;
